import React from "react";

const FinalCta = () => (
  <section className="cta" aria-labelledby="about-cta-title">
    <div className="wrap">
      <h2 id="about-cta-title">
        Read this far? You are <em>our kind of person</em>.
      </h2>
      <p>
        Find a course you would genuinely enjoy, or bring 42courses to your
        team.
      </p>
      <div className="btn-group">
        <a href="/courses" className="btn btn-primary">
          Browse all courses
        </a>
        <a href="/team_plans" className="btn btn-secondary">
          For teams & companies
        </a>
      </div>
    </div>
  </section>
);

export default FinalCta;
